module.exports = __webpack_public_path__ + "static/media/pinpai.053a5083.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/home/pinpai.png
// module id = 448
// module chunks = 0